import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class JobsService {

  url = `${environment.apiUrl}/jobs`;
  constructor(
    private http: HttpClient
  ) { }

  getJobs() {
    return this.http.get(this.url);
  }

  getJob(code: any) {
    return this.http.get(`${this.url}/${code}`);
  }

  getJobExecutions(code: any) {
    return this.http.get(`${this.url}/${code}/executions`);
  }

  updateJob(code: string, updatedJob: any) {
    return this.http.put(`${this.url}/${code}`, updatedJob);
  }

  runJob(code: string) {
    return this.http.post(`${this.url}/${code}/run`, {});
  }
}
